export const PRIMARY_NAV_ITEMS = [
  {
    key: "about",
    labelKey: "sidebar.about",
    to: "/about",
  },
  {
    key: "services",
    labelKey: "sidebar.services",
    to: "/services",
  },
  {
    key: "work",
    labelKey: "sidebar.cases",
    to: "/work",
  },
  {
    key: "contact",
    labelKey: "sidebar.contact",
    to: "/contact",
  },
];
